import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import useRouting from "../hooks/useRouting";
import { trackEvent } from "../utils/trackEvent";
import environment from "../environment";
import axios from "axios";
import Header from "./Header";
import Modal from "./Modal";
import "./OTPVerification.css";
import "./Modal.css";
import pencil_4887028 from "../assets/images/pencil_4887028.svg";
import MedicalBill from "../assets/images/MedicalBill.svg";
import InstantApproval from "../assets/images/InstantApproval.svg";
import SaveIcon from "../assets/images/SaveIcon.svg";
import QualityTreatment from "../assets/images/QualityTreatment.svg";
import { setStorage, getStorage, getHeaders } from "../utils/apiUtils";

const OTPVerification = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    type: "info"
  });
  const [searchParams] = useSearchParams();
  const { navigateWithContext, navigateBack, anchor } = useRouting();
  const inputRefs = useRef([]);

  useEffect(() => { trackEvent("loan_otp_viewed"); }, []);

  const showModal = (title, message, type = "info") => {
    setModal({
      isOpen: true,
      title,
      message,
      type
    });
  };

  const closeModal = () => {
    setModal(prev => ({ ...prev, isOpen: false }));
  };

  useEffect(() => {
    const storedPhone = localStorage.getItem("phoneNumber");
    if (storedPhone) {
      setPhoneNumber(storedPhone);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOtpChange = (index, value) => {
    if (value.length > 1) return; // Only allow single digit

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async () => {
    const otpValue = otp.join("");
    trackEvent("loan_otp_verify_clicked", { otp_valid: otpValue.length === 4 });
    if (otpValue.length === 4) {
      try {
        // Prepare payload
        const payload = {
          otp: otpValue,
          journey_type: "instant",
          mobile: localStorage.getItem("phoneNumber"),
          anchor: anchor,
        };

        // Call API to verify OTP
        const response = await axios.post(
          `${environment.apiurl_agentCode}auth/verify-otp/`,
          payload
        );

        // Check if response is successful
        if (response?.data && response?.data?.msg) {
          // Store OTP verification status
          localStorage.setItem("otpVerified", "true");

          // Store token and user details
          setStorage("token", response.data.msg.token);
          const userdetail = response?.data?.msg?.items[0];
          setStorage("name", userdetail?.personal?.full_name);
          setStorage("application_id", userdetail?.id);
          await handleDecision();
          await digitalMarketingCapture(userdetail?.id);

          // Use new routing
          // navigateWithContext("loan-type");
        } else {
          // Handle API error response
          const errorMessage =
            response?.data?.message || "Invalid OTP. Please try again.";
          showModal("Error", errorMessage, "error");
        }
      } catch (error) {
        console.error("Error verifying OTP:", error);

        // Handle different types of errors
        let errorMessage = "Failed to verify OTP. Please try again.";

        if (error.response) {
          // Server responded with error status
          errorMessage =
            error.response.data?.message ||
            `Server Error: ${error.response.status}`;
        } else if (error.request) {
          // Network error
          errorMessage =
            "Network error. Please check your internet connection.";
        }
          showModal("Error", errorMessage, "error");

        //alert(errorMessage);
      }
    }
  };

  // Digital marketing capture method
  const digitalMarketingCapture = async (application_id) => {
    try {
      const params = Object.fromEntries(searchParams);
      const utm_source = params?.utm_source;


      if (utm_source) {
        const payload = {
          utm_source: stripQuotes(params?.utm_source),
          utm_campaign: stripQuotes(params?.utm_campaign),
          utm_medium: stripQuotes(params?.utm_medium),
          utm_content: stripQuotes(params?.utm_content),
          utm_term: stripQuotes(params?.utm_term),
          application: application_id,
        };

        const response = await axios.post(
          `${environment.apiurl}campaign/create/`,
          payload
        );

        console.log(response);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  // Helper function to strip surrounding quotes from UTM parameters
const stripQuotes = (value) => {
  if (!value) return value;
  // Remove surrounding quotes if present
  return value.replace(/^"(.*)"$/, '$1');
};

  // const handleDecision = async () => {
  //   try {
  //     const applicationId = getStorage("application_id");
  //     if (!applicationId) {
  //       console.error("Application ID not found");
  //       return;
  //     }

  //     const statusResponse = await axios.get(
  //       `${environment.apiurl}applications/${applicationId}/ui_management_multi/loan/status/`,
  //       { headers: getHeaders() }
  //     );

  //     if (statusResponse.data && statusResponse.data.msg) {
  //       const status = statusResponse.data.msg.status;

  //       if (status === "1" || status === "") {
  //         navigateWithContext(`loan-type`);
  //       } else if (status === "send-to-lender-complete") {
  //         await fetchLenderStatus();
  //       } else {
  //         navigateWithContext(status);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Decision error:", error);
  //     showModal("Error", "An error occurred. Please try again.", "error");
  //   }
  // };
const handleDecision = async () => {
  try {
    const applicationId = getStorage("application_id");
    if (!applicationId) {
      console.error("Application ID not found");
      return;
    }

    const statusResponse = await axios.get(
      `${environment.apiurl}applications/${applicationId}/ui_management_multi/loan/status/`,
      { headers: getHeaders() }
    );

    if (statusResponse.data && statusResponse.data.msg) {
      const status = statusResponse.data.msg.status;

      if (status === "1" || status === "") {
        navigateWithContext("loan-type");
      } else if (status === "send-to-lender-complete") {
        // 🔥 removed fetchLenderStatus
        navigateWithContext("loan-type"); // or any page you want
      } else {
        navigateWithContext(status);
      }
    }
  } catch (error) {
    console.error("Decision error:", error);
    showModal("Error", "An error occurred. Please try again.", "error");
  }
};

  const handleResend = async () => {
    try {
      // // Prepare payload for resend OTP
      const payload = {
        mobile: localStorage.getItem('phoneNumber'),
        anchor: anchor.toUpperCase()
      };

      // Call API to resend OTP
      const response = await axios.post(
        `${environment.apiurl}auth/get-otp-generic/`,
        payload
      );

      // Check if response is successful
      if (response?.data && response?.data?.msg) {
        // Reset OTP inputs on successful resend
        setOtp(["", "", "", ""]);
        inputRefs.current[0].focus();
        showModal("Success", "OTP sent successfully!", "success");
      } else {
        // Handle API error response
        const errorMessage =
          response?.data?.message || "Failed to resend OTP. Please try again.";
        showModal("Error", errorMessage, "error");
      }
    } catch (error) {
      console.error("Error resending OTP:", error);

      // Handle different types of errors
      let errorMessage = "Failed to resend OTP. Please try again.";

      if (error.response) {
        // Server responded with error status
        errorMessage =
          error.response.data?.message ||
          `Server Error: ${error.response.status}`;
      } else if (error.request) {
        // Network error
        errorMessage = "Network error. Please check your internet connection.";
      }

        showModal("Error", errorMessage, "error");


      //alert(errorMessage);
    }
  };

  const handleBack = () => {
    // Use new routing
    navigateBack("");
  };

  const handleEditPhoneNumber = () => {
    navigateWithContext("");
  };

  const isOtpComplete = otp.every((digit) => digit !== "");

  return (
    <>
      <Modal
        isOpen={modal.isOpen}
        onClose={closeModal}
        title={modal.title}
        message={modal.message}
        type={modal.type}
      />
    <div className="loan-container">
      <Header showBackButton={false} onBackClick={handleBack} />

      <div className="main-content">
        <div className="hero-card">
          <div className="hero-section">
            <h1 className="hero-title">
              We will pay your
              <br />
              Hospital Bills
            </h1>
            <p className="hero-subtitle">
              Get instant medical loans
              <br />
              at zero cost
            </p>
            <div className="hero-icon">
              <img src={MedicalBill} alt="Medical Bill" />
            </div>
          </div>
        </div>

        <div className="features-card">
          <ul className="features-list">
            <li className="feature-item">
              <div className="feature-icon">
                <img src={SaveIcon} alt="Save Icon" />
              </div>
              <span className="feature-title">
                Save up to ₹10,000 on <br /> interest cost
              </span>
            </li>
            <li className="feature-item">
              <div className="feature-icon">
                <img src={QualityTreatment} alt="QualityTreatment" />
              </div>
              <span className="feature-title">
                Quality treatment at your preferred network hospital
              </span>
            </li>
            <li className="feature-item">
              <div className="feature-icon">
                <img src={InstantApproval} alt="Instant Approval" />
              </div>
              <span className="feature-title">
                Instant approval for medical expenses up to ₹3 lakhs
              </span>
            </li>
          </ul>
        </div>

        <div className="form-card">
          <div className="otp-section">
            <div className="otp-message">
              We&apos;ve sent an OTP
              <br />
              to mobile number{" "}
              <span className="phone-number-wrapper">
                <span className="phone-number">{phoneNumber}</span>
                <img
                  className="disclaimer-icon"
                  src={pencil_4887028}
                  alt="pencil"
                  onClick={handleEditPhoneNumber}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>

            <div className="form-title-otp">Enter OTP</div>

            <div className="otp-input-container">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  className={`otp-input ${digit ? "filled" : ""}`}
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  maxLength={1}
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              ))}
            </div>

            <div className="resend-section">
              <span className="resend-text">Didn&apos;t receive your OTP? </span>
              <button className="resend-link" onClick={handleResend}>
                Resend OTP
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="fixed-button-container">
        <button
          className="continue-button"
          onClick={handleSubmit}
          disabled={!isOtpComplete}
        >
          SUBMIT
        </button>
      </div>
    </div>
    </>
  );
};

export default OTPVerification;
